import { handleActions } from 'redux-actions';
import { actions } from '../actions/typing';
// Destructure the typing actions.
export const { typingSend, typingSendSucceeded, typingSendFailed, typingAdd, typingRemove, } = actions;
// Init state for the Typing.
const initialState = {
    meta: {
        asyncStatus: 'succeeded',
    },
    typings: [],
};
// Reducer
const typing = handleActions({
    // typing actions.
    [typingSend.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [typingSendSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [typingSendFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [typingAdd.toString()]: (state, action) => {
        const typings = state.typings.slice();
        let found = false;
        const typing = {
            csid: action.payload.params.csid,
            userId: action.payload.params.user_id,
        };
        for (const t of typings) {
            if (typing.csid === t.csid) {
                found = true;
            }
        }
        if (found === false) {
            typings.push(typing);
        }
        return Object.assign(Object.assign({}, state), { typings: typings });
    },
    [typingRemove.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { typings: state.typings.filter((t) => t.csid !== action.payload.params.csid) });
    },
}, initialState);
export default typing;
